<template>
  <div style="position: relative; height: 650px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Table :columns="tableTitle" :data="list" border stripe height="580">
      <template slot="expense" slot-scope="{ row, index }">
        <Select
          v-model="list[index].expense_item_id"
          filterable
          clearable
          :placeholder="$t('select') + $t('exlType')"
          :filter-by-label="true"
          :disabled="
            row.allow_del == 0
              ? true
              : rows.status == 'WAIT_CONFIRM'
              ? false
              : true
          "
          :transfer="true"
        >
          <Option
            v-for="item in expenseList"
            :value="item.id"
            :key="item.id"
            :label="item.name"
            @click.native="list[index].expense_item_name = item.name"
          >
          </Option>
        </Select>
      </template>
      <template slot="amount_cny" slot-scope="{ row, index }">
        <Input
          v-model="list[index].amount_cny"
          :disabled="
            row.allow_del == 0 || list[index].amount_cny != 0
              ? true
              : rows.status == 'WAIT_CONFIRM'
              ? false
              : true
          "
        />
      </template>
      <template slot="amount_usd" slot-scope="{ row, index }">
        <Input
          v-model="list[index].amount_usd"
          :disabled="
            row.allow_del == 0 || list[index].amount_usd != 0
              ? true
              : rows.status == 'WAIT_CONFIRM'
              ? false
              : true
          "
        />
      </template>
      <template slot="operation" slot-scope="{ row, index }">
        <template v-if="index == 0">
          <Button
            type="warning"
            @click="addClick()"
            icon="md-add"
            style="margin-right: 5px"
            size="small"
          >
            {{ $t("add") }}
          </Button>
        </template>
        <Button
          @click="delClick(index)"
          icon="ios-trash"
          :disabled="
            row.allow_del == 0 ? true : list.length == 1 ? true : false
          "
          size="small"
        >
          {{ $t("delete") }}
        </Button>
      </template>
    </Table>
    <div
      class="footer-btn"
      style="padding: 12px 18px 12px 18px; margin: 20px -16px 0px -16px"
    >
      <Button type="text" @click="close" style="margin-right: 8px">
        {{ $t("cancel") }}
      </Button>
      <Button type="primary" @click="save">
        {{ $t("confirm") }}
      </Button>
    </div>
  </div>
</template>
<script>
import { addFreight, getFreight } from "@/api/finance/bill";
import { getExpense } from "@/api/finance/expense";

export default {
  props: {
    rows: {
      type: Object,
    },
    close: {
      type: Function,
    },
  },
  data() {
    return {
      loading: true,
      list: [],
      expenseList: [],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("expense"),
        slot: "expense",
        align: "center",
        tooltip: "true",
      });
      columns.push({
        title: this.$t("reChAmount") + "(CNY)",
        slot: "amount_cny",
        align: "center",
        tooltip: "true",
      });
      columns.push({
        title: this.$t("reChAmount") + "(USD)",
        slot: "amount_usd",
        align: "center",
        tooltip: "true",
      });
      if (this.rows.status == "WAIT_CONFIRM") {
        columns.push({
          title: this.$t("operation"),
          slot: "operation",
          align: "center",
          tooltip: "true",
          width: 180,
        });
      }
      return columns;
    },
  },
  mounted() {
    this.SearchSubmit();
    this.getOtherList();
  },
  methods: {
    getOtherList() {
      getExpense().then((res) => {
        this.expenseList = res.data.payload.rows;
      });
    },
    addClick() {
      this.list.unshift({
        expense_item_id: "",
        expense_item_name: "",
        amount_cny: 0,
        amount_usd: 0,
        allow_edit: 1,
        allow_del: 1,
      });
    },
    delClick(index) {
      this.list.splice(index, 1);
    },
    SearchSubmit() {
      this.loading = true;
      getFreight(this.rows).then((res) => {
        this.list = res.data.payload;
        this.list.unshift({
          expense_item_id: "",
          expense_item_name: "",
          amount_cny: 0,
          amount_usd: 0,
          allow_edit: 1,
          allow_del: 1,
        });
        this.loading = false;
      });
    },
    save() {
      let data = {
        data: this.list.map((item) => {
          delete item.allow_edit;
          delete item.allow_del;
          return item;
        }),
        id: this.rows.id,
        fid: this.rows.fid,
      };
      addFreight(data).then((res) => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
          duration: res.data.status ? 2 : 5,
        });
        if (res.data.status) {
          this.close();
          this.SearchSubmit();
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.footer-btn {
  border-top: 1px solid #e8eaec;
  display: flex;
  justify-content: end;
  margin-top: 20px;
}
</style>
